import * as actionType from "./ActionTypes";

export default function CommonReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.PORTWISE_REPORT_LOADING:
      return (state = payload);
    default: 
      return  state;
  }
}
